import { render, staticRenderFns } from "./IcalImportLinks.vue?vue&type=template&id=5839f0aa&scoped=true&"
import script from "./IcalImportLinks.vue?vue&type=script&lang=js&"
export * from "./IcalImportLinks.vue?vue&type=script&lang=js&"
import style0 from "./IcalImportLinks.vue?vue&type=style&index=0&id=5839f0aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5839f0aa",
  null
  
)

export default component.exports